var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c, _d, _e, _f;
import { BaseSingletonService, Singleton } from '~/services/service.base';
import { action, makeObservable, observable, runInAction } from 'mobx';
import { ModelBookSheet } from '~/models';
import { MobxQuery } from '~/tools/mobx.query';
import { api } from '~/tools/api';
import { EApiUrl } from '~/tools/api/types';
import { plainToInstance } from 'class-transformer';
import { EBookSheetType } from '~/shared/types/book-sheet';
import { UIOpenService } from '~/services/service.ui';
import { ServiceOpenChapterItems } from '~/services/service.open.chapter.items';
export let ServiceBookCover = class ServiceBookCover extends BaseSingletonService {
    openContentService;
    openSectionService;
    openChapterService;
    sheets = observable.array([]);
    chapters = observable.array([]);
    pagesWithoutChapter = observable.array([]);
    allPages = observable.array([]);
    currentSheet;
    nextSheet;
    prevSheet;
    constructor(openContentService, openSectionService, openChapterService) {
        super();
        this.openContentService = openContentService;
        this.openSectionService = openSectionService;
        this.openChapterService = openChapterService;
        makeObservable(this);
    }
    clearData() {
        this.sheets.replace([]);
        this.chapters.replace([]);
        this.pagesWithoutChapter.replace([]);
        this.allPages.replace([]);
        this.currentSheet = undefined;
        this.nextSheet = undefined;
        this.prevSheet = undefined;
        this.openContentService.handleClose();
        this.openSectionService.handleClose();
    }
    getChapterPages(chapterId) {
        return this.sheets.filter(sheet => sheet.parentId === chapterId);
    }
    getSheetIndex(sheetId) {
        return this.allPages.findIndex(sheet => sheet.id === sheetId);
    }
    getNextSheet(sheetId) {
        const index = this.getSheetIndex(sheetId);
        return index >= 0 && index < this.allPages.length - 1 ? this.allPages[index + 1] : undefined;
    }
    getPrevSheet(sheetId) {
        const index = this.getSheetIndex(sheetId);
        return index > 0 ? this.allPages[index - 1] : undefined;
    }
    getCurrentSheet(sheetId) {
        const index = this.getSheetIndex(sheetId);
        return index >= 0 ? this.allPages[index] : undefined;
    }
    updateSheetNavigationData(sheetId) {
        this.prevSheet = this.getPrevSheet(sheetId);
        this.nextSheet = this.getNextSheet(sheetId);
        this.currentSheet = this.getCurrentSheet(sheetId);
    }
    getBookSheets(communityId, bookId) {
        return new MobxQuery({
            queryFn: (() => api
                .get(`${EApiUrl.communities}/${communityId}/${EApiUrl.books}/${bookId}/${EApiUrl.sheets}`)
                .then(response => {
                runInAction(() => {
                    const sheets = plainToInstance(ModelBookSheet, response.data);
                    this.sheets.replace(sheets);
                    this.chapters.replace(sheets.filter(sheet => sheet.type === EBookSheetType.chapter));
                    this.pagesWithoutChapter.replace(sheets.filter(sheet => !sheet.parentId && sheet.type !== EBookSheetType.chapter));
                    this.allPages.replace(sheets.filter(sheet => sheet.type === EBookSheetType.page));
                    [this.currentSheet] = this.allPages.toJSON();
                    this.nextSheet = this.getNextSheet(this.currentSheet?.id);
                    this.prevSheet = this.getPrevSheet(this.currentSheet?.id);
                });
            })),
        }).query();
    }
};
__decorate([
    observable,
    __metadata("design:type", Object)
], ServiceBookCover.prototype, "currentSheet", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ServiceBookCover.prototype, "nextSheet", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ServiceBookCover.prototype, "prevSheet", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ServiceBookCover.prototype, "clearData", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ServiceBookCover.prototype, "updateSheetNavigationData", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", void 0)
], ServiceBookCover.prototype, "getBookSheets", null);
ServiceBookCover = __decorate([
    Singleton(),
    __metadata("design:paramtypes", [typeof (_a = typeof UIOpenService !== "undefined" && UIOpenService) === "function" ? _a : Object, typeof (_b = typeof UIOpenService !== "undefined" && UIOpenService) === "function" ? _b : Object, typeof (_c = typeof ServiceOpenChapterItems !== "undefined" && ServiceOpenChapterItems) === "function" ? _c : Object])
], ServiceBookCover);
